import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import parse, { isValidPhoneNumber } from "libphonenumber-js";
import sortBy from "lodash/sortBy";
import { callingCodes, primaryCallingCodes, secondaryCallingCodes } from "./consts/CALLING_CODES";
export var ICountryCodeOption;
(function(ICountryCodeOption) {
    ICountryCodeOption.build = function(partial) {
        return _object_spread({
            label: "",
            countryCallingCode: ""
        }, partial);
    };
})(ICountryCodeOption || (ICountryCodeOption = {}));
var getPhoneFormat = function(country) {
    switch(country){
        case "United States of America":
        case "Canada":
            return "(###)-###-####";
        default:
            return undefined;
    }
};
var primaryOptions = function(strictLocalize) {
    return primaryCallingCodes(strictLocalize).concat(sortBy(secondaryCallingCodes(strictLocalize), "[0]")).map(function(param) {
        var _param = _sliced_to_array(param, 2), label = _param[0], countryCallingCode = _param[1];
        return {
            label: label !== null && label !== void 0 ? label : "",
            countryCallingCode: countryCallingCode !== null && countryCallingCode !== void 0 ? countryCallingCode : "",
            format: getPhoneFormat(label !== null && label !== void 0 ? label : "")
        };
    });
};
var allOptions = function(strictLocalize) {
    return callingCodes(strictLocalize).map(function(param) {
        var _param = _sliced_to_array(param, 2), label = _param[0], countryCallingCode = _param[1];
        return {
            label: label !== null && label !== void 0 ? label : "",
            countryCallingCode: countryCallingCode !== null && countryCallingCode !== void 0 ? countryCallingCode : ""
        };
    });
};
export var countryCallingCodeOptions = function(strictLocalize) {
    return primaryOptions(strictLocalize).concat(sortBy(allOptions(strictLocalize), "label"));
};
export var validatePhoneNumber = function(phoneNumber) {
    return phoneNumber ? isValidPhoneNumber(phoneNumber) : false;
};
export var parsePhoneNumber = function(phoneNumber, countryCodeOption, strictLocalize) {
    var options = countryCallingCodeOptions(strictLocalize);
    // Special-case for empty/default input.
    if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.trim()) === "+1") {
        var _options_;
        return {
            countryCallingCodeOption: (_options_ = options[0]) !== null && _options_ !== void 0 ? _options_ : ICountryCodeOption.build(),
            nationalPhoneNumber: ""
        };
    }
    var parsed = parse(phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : "");
    if (!(parsed === null || parsed === void 0 ? void 0 : parsed.isPossible())) {
        var _options_find, _ref, _ref1, _parsed_nationalNumber, _ref2;
        return {
            countryCallingCodeOption: (_ref1 = (_ref = (_options_find = options.find(function(c) {
                return c.countryCallingCode === "+".concat(parsed === null || parsed === void 0 ? void 0 : parsed.countryCallingCode);
            })) !== null && _options_find !== void 0 ? _options_find : countryCodeOption) !== null && _ref !== void 0 ? _ref : options[0]) !== null && _ref1 !== void 0 ? _ref1 : ICountryCodeOption.build(),
            nationalPhoneNumber: (_ref2 = (_parsed_nationalNumber = parsed === null || parsed === void 0 ? void 0 : parsed.nationalNumber) !== null && _parsed_nationalNumber !== void 0 ? _parsed_nationalNumber : phoneNumber) !== null && _ref2 !== void 0 ? _ref2 : ""
        };
    }
    var countryCallingCodeOption = options.find(function(option) {
        return "+".concat(parsed.countryCallingCode) === option.countryCallingCode;
    });
    if (!countryCallingCodeOption) {
        var _options_1;
        return {
            countryCallingCodeOption: (_options_1 = options[0]) !== null && _options_1 !== void 0 ? _options_1 : ICountryCodeOption.build(),
            nationalPhoneNumber: parsed.nationalNumber
        };
    }
    return {
        countryCallingCodeOption: countryCallingCodeOption,
        nationalPhoneNumber: parsed.nationalNumber
    };
};
